"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRecalculatedPrice = exports.updateBookingServices = exports.showBookingServices = exports.setShouldRecalculatePrice = exports.setRecalculatedPrice = exports.setLastRecalculatedActiveServices = exports.setIsShow = exports.setActiveServicesById = exports.setActiveServices = exports.recalculateOfferPrice = exports.hideBookingServices = exports.forceApplyRecalculate = exports.detachService = exports.detachActiveServicesById = exports.bookingServicesActions = exports.applyService = void 0;
var _reduxActions = require("redux-actions");
var PREFIX = 'OFFER_DETAILS/BOOKING_SERVICES';
var bookingServicesActions = exports.bookingServicesActions = (0, _reduxActions.createActions)({
  showBookingServices: function showBookingServices(offerID, queryID) {
    return {
      offerID: offerID,
      queryID: queryID
    };
  },
  hideBookingServices: function hideBookingServices(offerID, queryID) {
    return {
      offerID: offerID,
      queryID: queryID
    };
  },
  setIsShow: function setIsShow(isShow) {
    return isShow;
  },
  updateBookingServices: function updateBookingServices(offerID, queryID) {
    return {
      offerID: offerID,
      queryID: queryID
    };
  },
  applyService: function applyService(serviceID, touristId) {
    return {
      serviceID: serviceID,
      touristId: touristId
    };
  },
  detachService: function detachService(serviceID, touristId) {
    return {
      serviceID: serviceID,
      touristId: touristId
    };
  },
  setActiveServicesById: function setActiveServicesById(serviceID, touristIds) {
    return {
      serviceID: serviceID,
      touristIds: touristIds
    };
  },
  detachActiveServicesById: function detachActiveServicesById(serviceID) {
    return {
      serviceID: serviceID
    };
  },
  setActiveServices: function setActiveServices(services) {
    return services;
  },
  recalculateOfferPrice: function recalculateOfferPrice(offerID, queryID, bookingEntity) {
    return {
      offerID: offerID,
      queryID: queryID,
      bookingEntity: bookingEntity
    };
  },
  setRecalculatedPrice: function setRecalculatedPrice(price) {
    return price;
  },
  setLastRecalculatedActiveServices: function setLastRecalculatedActiveServices(services) {
    return services;
  },
  setShouldRecalculatePrice: function setShouldRecalculatePrice(should) {
    return should;
  },
  updateRecalculatedPrice: function updateRecalculatedPrice(price) {
    return price;
  },
  forceApplyRecalculate: function forceApplyRecalculate() {
    return undefined;
  }
}, {
  prefix: PREFIX
});
var showBookingServices = exports.showBookingServices = bookingServicesActions.showBookingServices,
  hideBookingServices = exports.hideBookingServices = bookingServicesActions.hideBookingServices,
  setIsShow = exports.setIsShow = bookingServicesActions.setIsShow,
  updateBookingServices = exports.updateBookingServices = bookingServicesActions.updateBookingServices,
  recalculateOfferPrice = exports.recalculateOfferPrice = bookingServicesActions.recalculateOfferPrice,
  setRecalculatedPrice = exports.setRecalculatedPrice = bookingServicesActions.setRecalculatedPrice,
  setShouldRecalculatePrice = exports.setShouldRecalculatePrice = bookingServicesActions.setShouldRecalculatePrice,
  setLastRecalculatedActiveServices = exports.setLastRecalculatedActiveServices = bookingServicesActions.setLastRecalculatedActiveServices,
  updateRecalculatedPrice = exports.updateRecalculatedPrice = bookingServicesActions.updateRecalculatedPrice,
  applyService = exports.applyService = bookingServicesActions.applyService,
  detachService = exports.detachService = bookingServicesActions.detachService,
  setActiveServicesById = exports.setActiveServicesById = bookingServicesActions.setActiveServicesById,
  detachActiveServicesById = exports.detachActiveServicesById = bookingServicesActions.detachActiveServicesById,
  setActiveServices = exports.setActiveServices = bookingServicesActions.setActiveServices,
  forceApplyRecalculate = exports.forceApplyRecalculate = bookingServicesActions.forceApplyRecalculate;